// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useEffect, useMemo, useRef, useState} from 'react';
import cn from 'classnames';
import {Proxy_type, t_order} from '../../../../hola/pub/ui/pro/cp/orders';
import {api} from '../../../../toolip/pub/lib/api';
import {use_etask} from '../../../../hola/pub/lib/use_etask';
import {use_click_outside} from '../../../../hola/pub/lib/use_click_outside';
import Icon_check from '../../img/icons/16/check.svg';
import Icon_close from '../../img/icons/16/close.svg';
import Icon_warning from '../../img/icons/16/warning.svg';
import {use_app_context} from '../../lib/app_context';
// @ts-ignore
import {code2label} from 'zcountry';
import {get_generated_proxies} from '../dashboard/utils';
import {Flag} from '../../../../hola/pub/lib/flag';
import {Confirmation_dialog} from '../../../../shared/ui/dialogs/confirmation';
import styles from './rotate_proxies.module.less';
import {Rotate_approval_dialog} from '../../../../shared/ui/dialogs/rotate_approval_dialog';

type t_refresh_params = {
    title: string;
    use_case: 'twitch' | 'tickets' | 'email_farming' | 'grass';
};

const rotate_ips: t_refresh_params[] = [{
    title: 'Twitch',
    use_case: 'twitch',
}, {
    title: 'Tickets',
    use_case: 'tickets',
}, {
    title: 'Emails farm',
    use_case: 'email_farming',
}, {
    title: 'Grass',
    use_case: 'grass',
}];

export const use_rotate_proxy = (order: t_order)=>{
    const {exec, state} = use_etask<[string, string],
        {success: boolean, error: string}>(api.zone_set_use_case);
    const do_rotate = (use_case: string)=>order && exec(order._id, use_case);
    return {rotate_state: state, do_rotate};
};

interface i_rotate_proxy_props {
    order: t_order;
    icon?: React.ReactNode;
    btn_loader: React.ReactNode;
    do_rotate: (use_case: string)=>void;
    state: {
        loading: boolean;
        data: {
            success: boolean;
            error: string;
        };
    }
}
export const Rotate_proxy = (props: i_rotate_proxy_props)=>{
    const {order, state, do_rotate} = props;
    const [opened, set_opened] = useState(false);
    const {dashboard} = use_app_context();
    useEffect(()=>{
        if (state.data?.success)
            dashboard.dispatch({type: 'refresh_orders'});
    }, [state.data?.success]);
    const toggle = (value?: boolean)=>{
        if (value===undefined)
            set_opened(v=>!v);
        else
            set_opened(value);
    };
    const is_rotated = state.data?.success || order.rotated_by_user_ts;
    const label = state.loading ? props.btn_loader
        : is_rotated ? <><Icon_check/>Proxies rotated</>
        : <>Rotate proxies{props.icon}</>;
    const can_rotate = !state.loading && !is_rotated;
    const [approval_open, set_approval_open] = useState(false);
    const [pending_use_case, set_pending_use_case] =
        useState<string|null>(null);
    return <div
      className={cn(styles.rotate_proxy, styles.popup_anchor,
        state.data?.success && styles.rotated,
        is_rotated && styles.rotated,
      )}
      data-tt={is_rotated && 'Proxy rotation is limited to once '+
        'per subscription and will reset at your next renewal.'}>
      <Select
        label={label}
        opened={opened}
        toggle={can_rotate ? toggle : null}
        items={rotate_ips.map(({title, use_case})=>({
          title,
          on_click: ()=>{
            if (!can_rotate)
              return;
            set_pending_use_case(use_case);
            set_approval_open(true);
            toggle(false);
          },
        }))}
      />
      <Rotate_approval_dialog
        is_open={approval_open}
        loading={state.loading}
        on_close={()=>{
          set_approval_open(false); set_pending_use_case(null);
        }}
        on_confirm={()=>{
          if (!pending_use_case)
            return;
          do_rotate(pending_use_case);
          set_approval_open(false);
          set_pending_use_case(null);
        }}
        cls={styles.pos_below_right}
      />
    </div>;
};

interface i_select_props {
    items: {title: React.ReactNode, on_click: ()=>void}[];
    label: React.ReactNode;
    opened: boolean;
    toggle?: (v?: boolean)=>void;
}
export const Select = (props: i_select_props)=>{
    const {items, opened, label, toggle} = props;
    const select_ref = useRef<HTMLDivElement>();
    use_click_outside(select_ref, ()=>toggle?.(false));
    const select_cls = cn(styles.select, opened && styles.opened);
    return <div className={select_cls} ref={select_ref}>
      <p data-elem="title" onClick={()=>toggle?.()}>{label}</p>
      <ul data-elem="list">
        {items.map((item, idx)=>
          <li key={idx} data-elem="item"
            onClick={item.on_click}>
            <span data-elem="item_title">{item.title}</span>
          </li>)}
      </ul>
    </div>;
};

export const Rotate_error = ({show_icon}: {show_icon: boolean})=>{
    return <div className={styles.rotate_error}>
      {show_icon && <Icon_warning/>}
      No servers available! Please try again later.
    </div>;
};


interface i_rotate_countries_props {
    flag_round: boolean;
    order: t_order;
    btn_loader: React.ReactNode;
}
export const Rotate_countries = (props: i_rotate_countries_props)=>{
    const {order, flag_round} = props;
    const {dashboard} = use_app_context();
    const can_rotate = order?.unit == 'ip' &&
        [Proxy_type.DDC, Proxy_type.SDC, Proxy_type.ISP].includes(order?.type);
    const removed_idx_ref = useRef<number>(null);
    const by_country = useMemo(()=>{
        return get_generated_proxies(order).filter(p=>p.manually_changed)
            .reduce((acc, p)=>{
                acc[p.country] = (acc[p.country]||0) + 1;
                return acc;
            }, {} as object_of<number>);
    }, [order]);
    const {exec, state} = use_etask<[string, string],
        {success: boolean, error: string}>(api.zone_rotate_by_country);
    const do_rotate = (country: string)=>{
        if (state.loading)
            return;
        if (order)
            exec(order._id, country);
    };
    useEffect(()=>{
        if (state.data?.success)
            dashboard.dispatch({type: 'refresh_orders'});
    }, [state.data?.success]);
    useEffect(()=>{
        removed_idx_ref.current = null;
    }, [order?._id]);
    let [rotate_country, set_rotate_country] = useState<string>(null);
    let title = <>Are you sure you want to remove your
      <span className={styles.rotate_bold_text}>
        {` ${by_country[rotate_country]} ${code2label(rotate_country || '')}`}
      </span> configured proxies?
    </>;
    let countries = Object.entries(by_country).map(([c_code, count])=><li
      key={c_code}
      onClick={()=>can_rotate && set_rotate_country(c_code)}
      className={cn(styles.country_item, can_rotate && styles.rotate)}>
      <Flag country={c_code} round={flag_round} />
      <span className={styles.country}>{code2label(c_code)}</span>
      <span className={styles.count_wrap}>
        <span className={cn(styles.count)}>{count}</span>
        {can_rotate && <span className={cn(styles.x)}><Icon_close/></span>}
      </span>
    </li>);
    if (removed_idx_ref.current != null && state.data?.success)
    {
        countries.splice(removed_idx_ref.current, 0,
          <Removed_country key="removed"/>);
    }
    return <>
      <Confirmation_dialog is_open={!!rotate_country} width={400}
        title='Removing proxies'
        sub_title={title}
        close={()=>set_rotate_country(null)}
        caption_cancel='Cancel'
        caption_confirm='Remove proxies'
        on_confirm={()=>{
          removed_idx_ref.current
            = Object.keys(by_country).indexOf(rotate_country);
          do_rotate(rotate_country);
          set_rotate_country(null);
        }}/>
      <ul className={styles.by_country}>
        {countries}
      </ul>
    </>;
};

const Removed_country = ()=>{
    return <li className={cn(styles.country_item, styles.removed)}>
      Proxies removed<Icon_check />
    </li>;
};

